<!-- Chart with card wrapper (default behavior) -->
<mat-card *ngIf="useCardWrapper" [class.mat-card-inline-sm]="slimMode" [class.h-100]="fillHeight">
  <div *ngIf="loading">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  </div>
  
  <mat-card-content>
    <mat-card-title fxLayout="row" fxLayoutAlign="space-between">
      <div>
        {{ title }}
      </div>
      <div class="chart-type-container" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="2px">
        <mat-icon class="chart-icon" [class.selected-chart-icon]="type === 'bar'" *ngIf="type !== 'pie' && type !== 'horizontalBar'" (click)="setChartType('bar')">bar_chart</mat-icon>
        <mat-icon class="chart-icon" [class.selected-chart-icon]="type === 'horizontalBar'" *ngIf="type !== 'pie'" (click)="setChartType('horizontalBar')">equalizer</mat-icon>
        <mat-icon class="chart-icon" [class.selected-chart-icon]="type === 'line'" *ngIf="type !== 'pie' && type !== 'horizontalBar'" (click)="setChartType('line')">show_chart</mat-icon>
        <mat-icon class="chart-icon" [class.selected-chart-icon]="type === 'pie'" *ngIf="!disablePie" (click)="setChartType('pie')">pie_chart</mat-icon>
      </div>
    </mat-card-title>
    <mat-card-subtitle *ngIf="subtitle"><ng-content></ng-content></mat-card-subtitle>
    <canvas
      baseChart
      [datasets]="data"
      [labels]="labels"
      [options]="chartOptions"
      [legend]="legend"
      [chartType]="type"
      [colors]="chartColors">
    </canvas>
  </mat-card-content>
</mat-card>

<!-- Chart without card wrapper (for embedding in other cards) -->
<div *ngIf="!useCardWrapper" class="chart-no-wrapper" [class.h-100]="fillHeight">
  <div *ngIf="loading" class="loading-bar">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  </div>
  
  <div class="chart-content">
    <div *ngIf="title" class="chart-title" fxLayout="row" fxLayoutAlign="space-between">
      <div>
        {{ title }}
      </div>
      <div class="chart-type-container" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="2px">
        <mat-icon class="chart-icon" [class.selected-chart-icon]="type === 'bar'" *ngIf="type !== 'pie' && type !== 'horizontalBar'" (click)="setChartType('bar')">bar_chart</mat-icon>
        <mat-icon class="chart-icon" [class.selected-chart-icon]="type === 'horizontalBar'" *ngIf="type !== 'pie'" (click)="setChartType('horizontalBar')">equalizer</mat-icon>
        <mat-icon class="chart-icon" [class.selected-chart-icon]="type === 'line'" *ngIf="type !== 'pie' && type !== 'horizontalBar'" (click)="setChartType('line')">show_chart</mat-icon>
        <mat-icon class="chart-icon" [class.selected-chart-icon]="type === 'pie'" *ngIf="!disablePie" (click)="setChartType('pie')">pie_chart</mat-icon>
      </div>
    </div>
    <div *ngIf="subtitle" class="chart-subtitle"><ng-content></ng-content></div>
    <canvas
      baseChart
      [datasets]="data"
      [labels]="labels"
      [options]="chartOptions"
      [legend]="legend"
      [chartType]="type"
      [colors]="chartColors">
    </canvas>
  </div>
</div>